import { ButtonPosition } from '@/common/manager/position/button-position';
export const config = {
    value: 'arraySubAreaCardRemove',
    position: [ButtonPosition.arraySubAreaCardOperate],
    action: (config) => {
        const { arrayBaseField, arrayBaseFieldIndex } = config || {};
        if (typeof arrayBaseField?.remove === 'function' &&
            typeof arrayBaseFieldIndex === 'number') {
            arrayBaseField.remove(arrayBaseFieldIndex);
        }
    },
};
